import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../Modal";
import { PostcodeInUseContent } from "./PostcodeInUseContent";
import { PostcodeInUseActions } from "./PostcodeInUseActions";
import { postcodeInUseModalContentSelector } from "../../../reducers/ownApp/selectors";
import { setPostcodeInUseModalContent } from "../../../reducers/ownApp";

export const PostcodeInUseModal = memo(() => {
  const dispatch = useDispatch();
  const content = useSelector(postcodeInUseModalContentSelector);

  const onContinue = () => dispatch(setPostcodeInUseModalContent(null));

  return (
    <Modal
      open={!!content}
      onClose={onContinue}
      title={"Unable to remove Postcode"}
      content={<PostcodeInUseContent content={content} />}
      actions={<PostcodeInUseActions onContinue={onContinue} />}
      maxWidth={"sm"}
    />
  );
});
